import { render } from "./BaseDetailsButton.vue?vue&type=template&id=8310870c"
import script from "./BaseDetailsButton.vue?vue&type=script&lang=js"
export * from "./BaseDetailsButton.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__